import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TaskLabelPopoverComponent } from '../task-label-popover/task-label-popover.component';
import { TaskLabel, Task } from '../../taskbook.types';
import { MatTooltip } from "@angular/material/tooltip";

@Component({
    selector: 'multi-task-label-popover-selector',
    templateUrl: './multi-task-label-popover-selector.component.html',
    styleUrls: ['./multi-task-label-popover-selector.component.scss', './../../taskbook-triage-actions/taskbook-triage-actions.component.scss', './../../task/task.component.scss', './../../../taskbook-backlog/task-detail-actions/task-detail-actions.component.scss'],
    standalone: true,
    imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    TaskLabelPopoverComponent,
    MatTooltip
]
})
export class MultiTaskLabelPopoverSelectorComponent implements OnChanges{

    labels: TaskLabel[] = [];

    @Input() selectedLabels: TaskLabel[];
    @Input() selectedItems: Task[];
    @Input() context: string;
    @Output() labelsChange = new EventEmitter<TaskLabel[]>();
  
    protected isPopoverOpen = false;

    constructor() {}

    ngOnChanges(): void {
      this.labels = this.selectedLabels ? this.selectedLabels : [];
    }


    onLabelSelectionChanged(labels: TaskLabel[]) {
      this.labels = labels;
    }

    togglePopover(): void {
      this.isPopoverOpen = !this.isPopoverOpen;
    }

    onApply(selectedLabels: TaskLabel[]) {
      this.labels = selectedLabels;
      this.labelsChange.emit(this.labels);
      this.isPopoverOpen = false;
      this.selectedLabels = [];
    }

  }
